// extracted by mini-css-extract-plugin
export default {"signInDialog":"SignInDialog_signInDialog__kmaNx","icon":"SignInDialog_icon__b7vvD","underlineText":"SignInDialog_underlineText__nxEpT"};